import React, { FC } from 'react'
import { Modal } from 'antd'
import { User, UserFormValues } from '../../types'
import { UserForm, useBreakpoints } from '..'

interface UserModalProps {
	isVisible: boolean
	close(): void
	user: User
	update(values: UserFormValues): Promise<void>
}

const EditUserModal: FC<UserModalProps> = ({ user, update, isVisible, close }) => {
	const breakpoints = useBreakpoints()

	return (
		<>
			<Modal centered={breakpoints.md} destroyOnClose footer={null} visible={isVisible} onCancel={close} title={`Editing: ${user.name}`}>
				<UserForm user={user} submit={update} />
			</Modal>
		</>
	)
}

export default EditUserModal
